import { Injectable } from '@angular/core';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { environment } from 'src/environments/environment';
import { ClientBaseApiService } from '../../../core/api/client-base-api.service';
import { TimelineRequest, TimelineResponse, TimelineStageResponse } from '../models/timeline';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IGenericResponse } from 'src/app/core/models/interfaces/i-generic-response';

@Injectable({
  providedIn: 'root'
})
export class TimelineService {

  constructor(private baseApiService: ClientBaseApiService) { }


  getTimelineList(farmId: number, cropId: number) {
    let url = environment.baseApiUrl + "v2/api/farm/timeline/logs/list?tempFarmAttId=" + farmId + "&cropId=" + cropId;
    return this.baseApiService.baseApiCall<TimelineResponse[]>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  saveTimeline(payload: TimelineRequest) {
    let url = environment.baseApiUrl + "v2/api/farm/timeline/logs/save";
    return this.baseApiService.baseApiCall({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }
  getPhenologyList(cropId: number) {
    let url = environment.baseApiUrl + "v2/api/farm/phenology/list/by/cropId?cropId=" + cropId;
    return this.baseApiService.baseApiCall<TimelineStageResponse[]>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
    // return this.baseApiService.serviceCallExternal('../../../../assets/dummy-data/timeline.json', {}, 'get')
  }
  deletePhenologyList(timelineId){
    let url = environment.baseApiUrl + "v2/api/farm/timeline/delete/logs/" + timelineId;
    return this.baseApiService.baseApiCall<TimelineStageResponse>({ url, payload: {}, requestType: HttpRequestTypes.GET })
  }

  saveTimelineRequest(timelinePayload: any): Observable<any> {
    let requestObj: any = {};
    Object.keys(timelinePayload).forEach((val, index) => {
      requestObj[val] = this.baseApiService.baseApiCall({ url: environment.baseApiUrl + "v2/api/farm/timeline/logs/save", payload: timelinePayload[val], requestType: HttpRequestTypes.POST }).pipe(catchError(val => of({ Data: false, IsSuccess: true, Message: "", StatusCode: 1 } as IGenericResponse<boolean>)));
    });
    return new Observable(observer => {
      forkJoin(requestObj).subscribe(res => {
        observer.next(res);
      }, err => { }, () => {

      })
    });
  }
}
